import { render } from "./InformationDestinationDetail.vue?vue&type=template&id=1c7a19c6"
import script from "./InformationDestinationDetail.vue?vue&type=script&lang=js"
export * from "./InformationDestinationDetail.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/admin.23paskal.id/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__